module.exports = __webpack_public_path__ + "media/images/luggage-bd1d82005ba7cd01851ace2ddf4ba4be.jpeg";